import { z } from "zod";

export const OnboardingSchema = z.object({
  professionType: z.enum([
    "GENERIC",
    "FITNESS_COACH",
    "PSYCHOLOGIST",
    "BUSINESS_COACH",
    "NUTRITIONIST",
    "SOPHROLOGIST",
  ]),
  defaultSessionPrice: z.number().min(0).default(0),
  depositEnabled: z.boolean().default(false),
  depositPercent: z.number().int().min(0).max(100).default(33),
  availability: z
    .array(
      z.object({
        dayOfWeek: z.number().int().min(0).max(6),
        startTime: z.string().regex(/^\d{2}:\d{2}$/),
        endTime: z.string().regex(/^\d{2}:\d{2}$/),
        isActive: z.boolean(),
      }),
    )
    .optional(),
});

export type OnboardingDto = z.infer<typeof OnboardingSchema>;
